import { getDefaultLocale } from '@/i18n'

/** API language: 0=CN, 1=EN (matches backend e_type) */
export function getApiLangType(locale) {
  const loc = locale || getDefaultLocale()
  return loc === 'en' ? 1 : 0
}

/** Merge eType into list query params based on site locale */
export function withLangParams(params, locale) {
  const p = Object.assign({}, params || {})
  if (locale != null) {
    p.eType = getApiLangType(locale)
  } else if (p.eType == null) {
    p.eType = getApiLangType(getDefaultLocale())
  }
  return p
}
